__webpack_require__.p = "/en/photodiode/";